export const components = {
  navigation: {
    helpMessage: {
      mobile: `Swipe around the screen or zoom it`,
      desktop: `Move around the screen or scroll it`
    }
  },

  notFound: {
    notFoundImageSrc: `../../../images/sup_seal.gif`
  }
}
